class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClassList = ['cart-drawer-is-open', 'overflow-hidden'];
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.calculateInitialQuantity();
  }

  open() {
    this.activeClassList.forEach((activeClass) => this.body.classList.add(activeClass));
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.activeClassList.forEach((activeClass) => this.body.classList.remove(activeClass));

    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.warn('Invalid parsedState or missing sections in renderContents');
      return;
    }

    const cartDrawerHtml = parsedState.sections['cart-drawer'];
    if (cartDrawerHtml) {
      const sourceDOM = new DOMParser().parseFromString(cartDrawerHtml, 'text/html');
      const pageCartItemsElement = this.querySelector('cart-items');
      const sourceCartItemsElement = sourceDOM.querySelector('cart-items');

      if (pageCartItemsElement && sourceCartItemsElement) {
        if (sourceCartItemsElement.classList.contains('cart-is-empty')) {
          pageCartItemsElement.classList.add('cart-is-empty');
        } else {
          pageCartItemsElement.classList.remove('cart-is-empty');
        }
      }

      const selectorsToUpdate = {
        items: '#main-cart-items .js-cart-item-contents',
        footer: '#main-cart-footer .js-cart-footer-contents',
        header: '#main-cart-header .js-cart-header-contents',
      };

      if (!sourceCartItemsElement?.classList.contains('cart-is-empty')) {
        Object.values(selectorsToUpdate).forEach((selector) => {
          const pageElement = this.querySelector(selector);
          const sourceElement = sourceDOM.querySelector(selector);

          if (pageElement && sourceElement) {
            pageElement.innerHTML = sourceElement.innerHTML;
          }
        });
      }
    } else {
      console.warn('Cart drawer section HTML missing from response.');
    }

    const cartIconBubbleHtml = parsedState.sections['cart-icon-bubble'];
    const cartIconBubbleSelector = '[data-cart-icon-bubble]';
    if (!cartIconBubbleHtml) return;

    const pageElement = document.querySelector(cartIconBubbleSelector);
    const sourceDOM = new DOMParser().parseFromString(cartIconBubbleHtml, 'text/html');
    const sourceElement = sourceDOM.querySelector(cartIconBubbleSelector);

    if (pageElement && sourceElement) {
      pageElement.innerHTML = sourceElement.innerHTML;
    }

    this.calculateInitialQuantity();
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  calculateInitialQuantity() {
    // Update price on each item aswell
    let itemPriceEl = this.querySelectorAll('.price__item, .cart-item__price span');

    if (itemPriceEl) {
      itemPriceEl.forEach((el) => {
        const qty = parseInt(
            el.closest('.cart-drawer-item').querySelector('.quantity__input').value
          ),
          itemPrice = el.textContent.trim().replace(',', '.');

        el.innerHTML = ' ' + (itemPrice * qty).toFixed(2);
      });
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
